import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import { EApiCallStateKey, EApiRequestPartKeys } from '@core/state/api-call-state/api-call-state.enum';
import { ApiCallStateActions } from '@core/state/api-call-state/api-call-state.actions';

/**
 * FiltersResetButtonComponent
 * @date 9/2/2023 - 5:06:27 PM
 *
 * @export
 * @class FiltersResetButtonComponent
 * @type {FiltersResetButtonComponent}
 */
@Component({
  selector: 'aup-filters-reset-button',
  templateUrl: './filters-reset-button.component.html',
  styleUrls: ['./filters-reset-button.component.scss'],
  standalone: false,
})
export class FiltersResetButtonComponent {
  /**
   * ApiCallStateKey
   * @date 9/2/2023 - 5:06:27 PM
   *
   * @type {EApiCallStateKey}
   */
  @Input() apiCallStateKey!: EApiCallStateKey;

  @Output() allFiltersReset: EventEmitter<void> = new EventEmitter<void>();
  /**
   * Creates an instance of FiltersResetButtonComponent.
   * @date 9/2/2023 - 5:06:27 PM
   *
   * @constructor
   * @param {Store} store$
   */
  constructor(private store$: Store) {}

  /**
   * Reset all filters values in store
   * @date 9/2/2023 - 5:06:27 PM
   */
  resetAllFilters() {
    this.store$.dispatch(
      ApiCallStateActions.resetAllFilters({
        apiCallStateKey: this.apiCallStateKey,
        removeAdvancedFilters: true,
      })
    );

    this.store$.dispatch(
      ApiCallStateActions.updateRequestPart({
        apiCallStateKey: this.apiCallStateKey,
        requestPartKey: EApiRequestPartKeys.PAGINATION,
        data: { page: 0 },
      })
    );

    this.store$.dispatch(ApiCallStateActions.load({ apiCallStateKey: this.apiCallStateKey }));
    this.allFiltersReset.emit();
  }
}
